@if (countryCode()) {
    <div class="flex items-center gap-2">
        <img
            slot="functions"
            class="w-5 h-5 object-cover"
            [class.rounded-full]="rounded()"
            [class.rounded-sm]="!rounded()"
            src="/assets/images/flags/{{ countryCode().toLowerCase() }}.svg"
            alt="{{ countryCode() }} Flag"
        />
        <span>{{ 'countries.' + countryCode().toLowerCase() | translate }}</span>
    </div>
}
